export enum WindowOrientation {
    PortraitPrimary = 0,
    PortraitSecondary = 180,
    LandscapePrimary = -90,
    LandscapeSecondary = 90,
}